'use client';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import queryString from 'query-string';
import styled from 'styled-components';

import { InputSearch } from '@/components/InputSearch/InputSearch';
import useDebounce from '@/hooks/useDebounce';
import { devices } from '@/styles/breakpoints';

export const HeadingBlog = ({ data }) => {
  const router = useRouter();

  const [inputValue, setValue] = useState('');

  const searchValue = useDebounce(inputValue, 400);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    setValue(inputValue);
  };

  const url = (search: number | string) => {
    if (!search) {
      return window.location.pathname;
    }
    return `?${queryString.stringify({
      search,
    })}`;
  };

  const handleSearch = () => {
    const newPath = url(inputValue);

    router.push(newPath);
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') return handleSearch();
  };

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  return (
    <Heading>
      <SummaryBlock>
        Result:<span>{data?.total || 0}</span>
      </SummaryBlock>
      <InputBlock>
        <InputSearch
          inputValue={inputValue}
          defaultValue={''}
          handleKeyPress={handleKeyPress}
          handleChange={handleChange}
          handleSearch={handleSearch}
        />
      </InputBlock>
    </Heading>
  );
};
const Heading = styled.div`
  display: flex;
  flex-direction: column-reverse;

  gap: 16px;
  width: 100%;
  padding: 0;
  margin-bottom: 24px;
  & input {
    width: 100%;
  }
  @media only screen and ${devices.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    & input {
      width: 360px;
    }
  }
`;

const InputBlock = styled.div``;
const SummaryBlock = styled.div`
  color: #4d4d4d;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  & span {
    color: #192d52;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;
